import api from "../api";
import authService from "./AuthService";
import axios from "axios";

const END_POINT = "/api/tasks";

/**
 * This method will load all Tasks from the database with a get http call
 * @returns {} it is returning a promise with all Tasks
 */
export async function getAllHttp() {
  return await api.get(`${END_POINT}`);
}

/**
 * This method will get a Task by it's id from the database with a get http call
 *
 * @param  {long} id id of the Task we want to get from the database
 * @returns {} it is returning a promise. You will have 200 status if there is Tasks with id
 */
export async function getById(id) {
  return await api.get(`${END_POINT}/${id}`);
}

/**
 * This method will get all Tasks with userId from the database with a get http call
 *
 * @param  {long} userId id of the user whose Tasks we want to get  from the database
 * @returns {} it is returning a promise. You will have 200 status if there is Tasks for userId
 */
export async function getByUserId(userId) {
  return await api.get(`${END_POINT}/user/${userId}`);
}

/**
 * This method will get all Tasks by user id from the database with a get http call
 *
 * @param  {long} interId id of the Intervention we want to get from the database
 * @returns {} it is returning a promise. You will have 200 status if there is a leave period for employeeId.
 */
export async function getByInterventionId(interId) {
  return await api.get(`${END_POINT}/intervention/${interId}`);
}

/**
 * This method will give Tasks containing 'search' with a get http call
 * @param  {String} search String that contains what will be searched
 * @returns {} it is returning a promise with the Task containing 'search'
 */
export async function getBySearchWord(search) {
  return await api.get(`${END_POINT}/search/${search}`);
}

/**
 * This method will give the number of Tasks containing 'search' with a get http call
 * @param  {String} search String used to search Tasks whose slug match with
 * @returns {} it is returning a promise with the number of Tasks containing 'search'
 */
export async function getCountWithSearchWord(search) {
  return await api.get(`${END_POINT}/count/${search}`);
}

/**
 * This method will fetch Tasks from the webservice Wdg2 with a get http call
 * @param  {Object - LogInUser} logInUser user dg2
 * @param {string - FirstDay} firstDay first day of desired interval with format date "yyyy-MM-dd"
 * @param {string - LastDay} lastDay last day of desired interval with format date "yyyy-MM-dd"
 */
export async function fetchAllTasksFromDG2Http(logInUser, firstDay, lastDay) {
  return await axios.get(
    `${process.env.VUE_APP_BASE_URL}${END_POINT}/dg2/${firstDay}/${lastDay}`,
    {
      headers: {
        Authorization: authService.getBearerToken(),
        "X-AUTH-TOKEN": `${logInUser.email}:${logInUser.password}`,
      },
    }
  );
}

/**
 * This method is creates a Task in the database with a post http call
 *
 * @param  {Object - taskDto} task object that we want to add into the database
 * @returns {} it is returning a promise with the added task
 */
export async function createTaskHttp(task) {
  return await api
    .post(`${END_POINT}`, {
      id: 0,
      taskIdDg2: 0,
      title: task.title,
      intervention: task.intervention,
      user: task.user,
      slug: task.slug,
      beginDate: task.beginDate,
      endDate: task.endDate,
      duration: task.duration,
      version: 0,
    })
    .catch(function (error) {
      return error.response.status;
    });
}

/**
 * This method updates a user from the database with a put http call
 *
 * @param  {Object - taskDto} task object that we want to update in the database
 * @returns {} it is returning a promise with the updated task
 */
export async function updateTaskHttp(task) {
  return await api
    .put(`${END_POINT}`, {
      id: task.id,
      taskIdDg2: task.taskIdDg2,
      title: task.title,
      intervention: task.intervention,
      user: task.user,
      slug: task.slug,
      beginDate: task.beginDate,
      endDate: task.endDate,
      duration: task.duration,
      version: task.version,
    })
    .catch(function (error) {
      return error.response.status;
    });
}

/**
 * This method deletes a Task from the database with a delete http call
 *
 * @param  {} id id of the task we want to delete from the database
 * @returns {} it is returning a promise. You will have 202 status if the task has been deleted successfully.
 */
export async function deleteTaskHttp(id) {
  return await api.delete(`${END_POINT}/${id}`).catch(function (error) {
    return error.response.status;
  });
}

/**
 * This method returns a list of tasks between dates and optionnaly for a given user
 *
 * @param {*} start String of a date (format yyyy-MM-dd) for start date of the chosen interval
 * @param {*} end String of a date (format yyyy-MM-dd) for end date of the chosen interval
 * @returns A promise containing all fetched Tasks according the time interval
 */
export async function getAssignedTasksBetweenDate(start, end) {
  return await api.get(`${END_POINT}/between/${start}/${end}`);
}

/**
 * This method will give the number of Tasks by user type with a get http call
 * @param  {String} type String of type of users we want to count tasks (must be a valid type of Enum UserType)
 * @returns {} it is returning a promise with the number of Tasks for user type
 */
export async function getTaskCountByUserType(type) {
  return await api.get(`${END_POINT}/count/userType/${type}`);
}

/**
 *
 * @param {*} start
 * @param {*} end
 * @param {*} userType
 * @returns
 */
export async function getTaskByUserTypeBetweenDate(start, end, userType) {
  return await api.get(
    `${END_POINT}/userType/${userType}/between/${start}/${end}`
  );
}
